if (!customElements.get("featured-packages")) {

  customElements.define(
    "featured-packages",

    class FeaturedPackages extends HTMLElement {

      constructor() {
        super();

        this.categories = [];
        this.packages = [];
      }


      connectedCallback() {

        this.categories = this.querySelectorAll(
          ".featured-packages__category"
        );

        this.packages = this.querySelectorAll(
          ".featured-packages__card"
        );


        this.bindEvents();


        /*
         * প্রথম category automatically active থাকবে
         */
        const firstCategory = this.categories[0];

        if (firstCategory) {
          this.filterPackages(
            firstCategory.dataset.category
          );
        }

      }


      bindEvents() {

        this.categories.forEach((category) => {

          category.addEventListener(
            "click",
            () => {

              const selectedCategory =
                category.dataset.category;


              /*
               * Active category update
               */

              this.categories.forEach((item) => {
                item.classList.remove("is-active");
              });

              category.classList.add("is-active");


              /*
               * Package filter
               */

              this.filterPackages(
                selectedCategory
              );

            }
          );

        });

      }


      filterPackages(category) {

        this.packages.forEach((packageCard) => {

          const packageCategory =
            packageCard.dataset.packageCategory;


          if (packageCategory === category) {

            packageCard.classList.remove(
              "is-hidden"
            );

          } else {

            packageCard.classList.add(
              "is-hidden"
            );

          }

        });

      }


      disconnectedCallback() {

    
      }

    }
  );

}